/**
 * Server-side utilities for auth and tenant config.
 * These can be called from _app.tsx getInitialProps and proxy.ts
 */
import { IncomingMessage } from 'http';

import { getAuthContext, UserAuthContext } from './auth';
import { getTenantConfig, TenantData } from './config-cache';

export type { UserAuthContext } from './auth';
export type { TenantData } from './config-cache';

/**
 * Get the host from the request
 */
export const getHostFromRequest = (req: IncomingMessage): string => {
  const forwardedHost = req.headers['x-forwarded-host'];
  if (typeof forwardedHost === 'string') {
    return forwardedHost;
  }
  // Get host from headers, fallback to localhost
  const host = req.headers.host;
  return host || 'localhost';
};

export const getRequestContext = async (
  req: IncomingMessage,
): Promise<{
  authContext: UserAuthContext;
  tenant: TenantData;
  cookiesToSet?: string[];
}> => {
  const host = getHostFromRequest(req);
  const { authContext, cookiesToSet } = await getAuthContext(host, req.headers);
  const tenant = await getTenantConfig(authContext.tenantId);

  return {
    authContext,
    tenant,
    cookiesToSet,
  };
};
